export default "__VITE_ASSET__dGXEcDfg__"